import dnsLookup from '../modules/dns-lookup';
import _ from 'lodash.escape';
import lookup from '../modules/lookup-result-handler';

const initialize = () => {
    const dnsLookupInstance = new dnsLookup();

    lookup(dnsLookupInstance, 'ns');
    lookup(dnsLookupInstance, 'mx');
    lookup(dnsLookupInstance, 'ownership_txt');
};

export default initialize;
